// Panel dimensions
export const PANEL_WIDTH = 450
export const PANEL_MIN_WIDTH = 320
export const PANEL_MAX_WIDTH = 800
export const PANEL_MOBILE_MIN_WIDTH = 280
export const PANEL_MAX_HEIGHT = 800

// Animation durations
export const ANIMATION_DURATION = 200
